$(document).ready(function () {
  $('.banner_list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: true
  });
  

   $('.product-slider').slick({
    dots: false,
    arrows:true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
   $('.usp-list').slick({
    dots: false,
    arrows:false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.products-slider-section .product-slider').slick('refresh');
  
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
  
  $('.products-slider-section .product-slider').slick('refresh');
  
});

$(document).on('click','.select-label', function () {
    if($(this).parent().hasClass('active')){
      $(this).parent().removeClass('active');
    }else{
      $('.dropdown').removeClass('active');
      $(this).parent().addClass('active');
    }
});
$(document).on('click','.dropdown-list li', function () {
    $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
    $(this).parents('.dropdown').removeClass('active');
    var variant_id = $(this).data('value');
    $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
});


// layouts grid & list
document.querySelectorAll('.layouts_list_grid button').forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault(); // prevent default button behavior

    const layout = this.dataset.layout; // "grid" or "list"
    console.log('Selected layout:', layout);

    // Optional: toggle active class
    document.querySelectorAll('.layouts_list_grid button')
      .forEach(btn => btn.classList.remove('active'));

    this.classList.add('active');


    const itemsContainer = document.querySelector('.product-grid-container #product-grid');

    if (layout === 'grid') {
      itemsContainer.classList.add('grid-view');
      itemsContainer.classList.remove('list-view');

      document.querySelectorAll('.layout_list.description')
        .forEach(el => el.classList.add('hidden'));

    } else if (layout === 'list') {
      itemsContainer.classList.add('list-view');
      itemsContainer.classList.remove('grid-view');

      document.querySelectorAll('.layout_list.description')
        .forEach(el => el.classList.remove('hidden'));
    }
  });
});


// PLP product images slider
document.addEventListener("DOMContentLoaded", (event) => {
  $('.card_product_images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true
  });
});

// PLP custom quickview & compare triggering
document.addEventListener('DOMContentLoaded', () => {

  document.addEventListener('click', (e) => {

    /* =========================
       QUICK VIEW
    ========================= */
    const quickViewBtn = e.target.closest('.card-icons-box .quick-view');
    if (quickViewBtn) {
      e.preventDefault();

      const productCard = quickViewBtn.closest(
        '.card-wrapper, .product-card, .grid__item'
      );
      if (!productCard) return;

      const originalQuickview = productCard.querySelector(
        '.quickview_container button.quick-add__submit'
      );

      if (originalQuickview) {
        originalQuickview.click();
      }

      return; // stop here if quickview matched
    }

    /* =========================
       COMPARE ITEM
    ========================= */
    const compareItemBtn = e.target.closest('.card-icons-box .compare_item');
    if (compareItemBtn) {
      e.preventDefault();

      const productCard = compareItemBtn.closest(
        '.card-wrapper, .product-card, .grid__item'
      );
      if (!productCard) return;

      const originalCompareBtn = productCard.querySelector(
        '.ldt-cp-product-grid-add-to-compare-container button.ldt-cp-relative'
      );

      if (originalCompareBtn) {
        originalCompareBtn.click();
      }
    }

  });

});



// social share icon print
document.addEventListener('click', function (e) {
  const printBtn = e.target.closest('.social_share_print');
  if (!printBtn) return;

  e.preventDefault();
  window.print();
});

// star rating on click scroll to review tab 
document.addEventListener('DOMContentLoaded', () => {
  const reviewWidget = document.querySelector('.product__info-container .jdgm-widget');
  const tabTrigger   = document.querySelector('.tab-container .tabs li[rel="tab2"]');

  if (!reviewWidget || !tabTrigger) return;

  reviewWidget.addEventListener('click', (e) => {
    e.preventDefault();

    // Trigger tab click
    tabTrigger.click();

    // Scroll to tab container (or tab content)
    const tabContainer = document.querySelector('.tab-container');

    if (tabContainer) {
      tabContainer.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});


  document.addEventListener('DOMContentLoaded', function () {
    const shortDesc = document.getElementById('collection-description-short');
    const fullDesc = document.getElementById('collection-description-full');
    const readMoreBtn = document.getElementById('read-more-btn');
    const readLessBtn = document.getElementById('read-less-btn');

    if (!shortDesc || !fullDesc || !readMoreBtn || !readLessBtn) return;

    readMoreBtn.addEventListener('click', function () {
      shortDesc.style.display = 'none';
      fullDesc.style.display = 'block';
      readMoreBtn.style.display = 'none';
      readLessBtn.style.display = 'inline-block';
    });

    readLessBtn.addEventListener('click', function () {
      shortDesc.style.display = 'block';
      fullDesc.style.display = 'none';
      readMoreBtn.style.display = 'inline-block';
      readLessBtn.style.display = 'none';
    });
  });


  /// custom add to cart


// let customAddToCartBtns = document.querySelectorAll(".js-custom-add-to-cart");
// customAddToCartBtns.forEach((btn) => {
//   btn.addEventListener("click", (e) => {
    
//     let variantId = e.target.closest(".js-custom-add-to-cart").getAttribute("data-variant-id");
//     let quantityValue = document.querySelector("[name='quantity']") ? document.querySelector("[name='quantity']").value : 1;
//     // console.log(e.target)
//     let spinner = e.target.closest(".js-custom-add-to-cart").querySelector(".loading__spinner");
//     spinner.classList.remove("hidden");
//     setTimeout(() => {
//       spinner.classList.add("hidden");
//     }, 900);
//     window.location = 'https://ogsavvy.com/cart.php?action=add&product_id=' + encodeURIComponent(variantId) + '&qty[]=' + encodeURIComponent(quantityValue);
//   })
// })

let customAddToCartBtns = document.querySelectorAll(".js-custom-add-to-cart");

customAddToCartBtns.forEach((btn) => {
  btn.addEventListener("click", (e) => {
    const clickedBtn = e.target.closest(".js-custom-add-to-cart");
    const variantId = clickedBtn.getAttribute("data-variant-id");
    const quantityInput = document.querySelector("[name='quantity']");
    const quantityValue = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    const spinner = clickedBtn.querySelector(".loading__spinner");

    if (!variantId || variantId === "null" || variantId === "") {
      alert("Please select a product variant first.");
      return;
    }

    if (isNaN(quantityValue) || quantityValue < 1) {
      alert("Please enter a valid quantity.");
      return;
    }

    spinner?.classList.remove("hidden");
    setTimeout(() => spinner?.classList.add("hidden"), 900);

    window.location = 'https://ogsavvy.com/cart.php?action=add&product_id=' + encodeURIComponent(variantId) + '&qty[]=' + encodeURIComponent(quantityValue);
  });
});